import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { ViewService } from '../services/view.service';
import { DocumentOutline } from '../objects/ViewObject';
import { ConversationService } from '../services/conversation.service';
import { ConfirmationService } from '../services/confirmation.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { Subscription } from 'rxjs';
import { ThemeSetting } from '../objects/ThemeObject';
import { ThemeSettingService } from '../services/theme-setting.service';
import { DetailService } from '../services/detail.service';

@Component({
  selector: 'app-document-outline',
  templateUrl: './document-outline.component.html',
  styleUrls: ['./document-outline.component.css']
})
export class DocumentOutlineComponent implements OnInit, OnDestroy {

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  
  isBusy: boolean;
  loaderConfig: any;
  documentOutlineList: DocumentOutline[] = [];
  isDisabled: boolean = false;
  private currentItem: string;
  private selectedItemId:string;
  private componentId: string;
  private childView: string;
  private previousComponentId: string;
  private sub: Subscription;
  private sub1: Subscription;

  constructor(private viewService: ViewService, private confirmationService: ConfirmationService, private conversationService: ConversationService, private globals: Globals, private detailService: DetailService,
    private contextMenuService: ContextMenuService, private workspaceService: WorkspaceService, private themeSettingService: ThemeSettingService) {
    this.sub = this.workspaceService.currentParentIdChanged$.subscribe(id => {
      if (this.componentId == id){
        this.isBusy = true;
        this.viewService.getDocumentOutlineCard(id).subscribe(result => {
          this.isBusy = false;
          this.documentOutlineList = JSON.parse(result);
        }, error => {
          this.isBusy = false;
        });
      }
    });

    this.sub1 = this.detailService.getDetailChanged$.subscribe(result => {
      if (result){
        this.isDisabled = false;
      }
    })
   }

  @Input() set setComponentId(id:string){
    if (id){
      this.componentId = id;
      this.previousComponentId = this.componentId;
      this.viewService.getDocumentOutlineCard(id).subscribe(result => {
        this.isBusy = false;
        this.documentOutlineList = JSON.parse(result);
        if (this.documentOutlineList.length > 0){
          if (this.documentOutlineList.filter(x => x.ItemId == this.selectedItemId).length == 0){
            this.selectedItemId = this.documentOutlineList.find(x => x.ViewOrder == 1).ItemId;
            this.selectItem(this.selectedItemId);
          }
        }
      }, error => {
        this.isBusy = false;
      });
    }
  }

  @Input() set setDocumentOutline(list: DocumentOutline[]){
    this.documentOutlineList = list;
  }

  @Input() set setChildComponentId(id: string){
    this.componentId = id;
  }

  @Output() selectedItem = new EventEmitter<any>();

  ngOnInit() {
    var themes:ThemeSetting = this.themeSettingService.getTheme();
    this.loaderConfig = themes;
    this.isBusy = true;
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
    if (this.sub1) this.sub1.unsubscribe();
  }

  pullPopup(outline: DocumentOutline) {
    //$event.stopPropagation();
    this.confirmationService.confirm(
      "Add Quick Phrase for " + outline.ItemDisplay,
      "",
      ["CANCEL", "OK"], true, "Add Quick Phrase...", true)
      .subscribe((respond) => {
        if (respond.answer == "OK"){
          this.conversationService.saveUtteranceForPersonalizedView(respond.inputText, outline.ItemId).subscribe(result => {
            console.log(result);
          })
          
        }
      });
  }

  public onContextMenu($event, item: DocumentOutline): void {
    this.currentItem = item.ItemId;
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  onCloseContextMenu() {
    this.currentItem = '';
  }

  getChild(id: string){
    this.viewService.getDocumentOutlineChildItems(this.componentId, id).subscribe(result => {
      this.documentOutlineList.find(x => x.ItemId == id).ChildList = JSON.parse(result);
    })
  }

  selectItem(id: string){
    this.selectedItemId = id;
    this.selectedItem.emit(0);
    this.isDisabled = true;
    this.viewService.selectOutlineItem(this.componentId, id).subscribe(result => {
      if(result){
        this.selectedItem.emit(result);
      }
      else{
        this.isDisabled = false;
      }
    }, error => {
      this.selectedItem.emit(1);
      this.isDisabled = false;
    })
  }

  onSelectedItem(id: string){
    this.selectedItem.emit(id);
  }
}
